import React from 'react';
import { colors } from '../global/variables';

export const RangeIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 6 Q 8 10, 12 14 Q 16 18, 12 22"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="12" cy="6" r="2" fill={color} />
    <circle cx="12" cy="22" r="2" fill={color} />
  </svg>
);

export const CalendarIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect x="4" y="5" width="16" height="16" rx="2" stroke={color} strokeWidth="2" fill="none" />
    <path d="M4 9h16" stroke={color} strokeWidth="2" />
    <path d="M8 3v4M16 3v4" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <circle cx="8" cy="13" r="1" fill={color} />
    <circle cx="12" cy="13" r="1" fill={color} />
    <circle cx="16" cy="13" r="1" fill={color} />
    <circle cx="8" cy="17" r="1" fill={color} />
    <circle cx="12" cy="17" r="1" fill={color} />
  </svg>
);

export const WeightIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M10 6h4a1 1 0 0 1 1 1v1h-6V7a1 1 0 0 1 1-1z"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M9 8h6l3 10H6l3-10z"
      stroke={color}
      strokeWidth="2"
      fill="none"
      strokeLinejoin="round"
    />
    <path d="M6 18h12" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const WeightHeavyIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M10 6h4a1 1 0 0 1 1 1v1h-6V7a1 1 0 0 1 1-1z" fill={color} />
    <path d="M9 8h6l3 10H6l3-10z" fill={color} />
    <path d="M6 18h12" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const WidthIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4 12h16M4 12l3-3m-3 3l3 3m13-3l-3-3m3 3l-3 3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HeightIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 4v16m0-16l-3 3m3-3l3 3m-3 13l-3-3m3 3l3-3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VanIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 23.37 24.14"
    fill="none"
    {...props}
  >
    <path
      d="M15.19,9.35h-7a.4.4,0,0,0-.39.32V14h7.79V9.74A.39.39,0,0,0,15.19,9.35Zm2.72-5.46a1.57,1.57,0,0,1,1.56,1.45v11H17.91V5.84a.37.37,0,0,0-.3-.38H5.86a.42.42,0,0,0-.4.32V16.36H3.89V5.45A1.56,1.56,0,0,1,5.34,3.9H17.91ZM10.12,15.58H7.79v1.55h2.33Zm5.46,0H13.24v1.55h2.34Zm.78-7.79a.79.79,0,0,1,.77.69V18.69a1.56,1.56,0,0,1-1.44,1.56H14V18.69H9.35v1.56H7.79a1.57,1.57,0,0,1-1.56-1.44V8.57a.79.79,0,0,1,.69-.78h9.44Z"
      fill={color}
      opacity="0.9"
    />
  </svg>
);

export const BatteryIcon = ({ size = 16, color = colors.primaryColor, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect x="3" y="7" width="16" height="10" rx="2" stroke={color} strokeWidth="2" fill="none" />
    <path
      d="M19 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <rect x="5.5" y="9.5" width="4" height="7" rx="0.5" fill={color} />
    <rect x="10.5" y="9.5" width="4" height="7" rx="0.5" fill={color} opacity="0.5" />
  </svg>
);

export const RechargeIcon = ({
  size = 24,
  color = colors.primaryColor,
  viewBox = '0 0 30 30',
  ...props
}) => (
  <svg
    id="tdRechargeIcon"
    width={size}
    height={size}
    viewBox={viewBox}
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
    y="20%"
    x="20%"
    {...props}
  >
    <path d="M12 22H10L11 13H5L11 2H13L12 11H18L12 22Z" fill={color} />
  </svg>
);
